import { TextBoxTypeEnum } from "../../../enums/TextBoxTypeEnum";
import {
  Button,
  DatePicker,
  Icon,
  ProvideTypeahead,
  Select,
  TextBox,
  Typeahead,
} from "../../../share/Elements";
import Card from "../../../share/Components/Card/Card";
import { useSelector } from "react-redux";
import useFetch from "../../../_services/fetch";
import { RaytebRequests } from "../../../_services";
import { ItemType } from "../../../models/ViewModels/RecordCatalogViewModel";
import { ReducerType } from "../../../storeManager/ReducerType";
import { LoginInterface } from "../../../Interfaces/LoginInterface";
import {
  RecordActionItem,
  RecordActionType,
} from "../../../models/ViewModels/RecordViewModel";
import { LoadingFit } from "../../../share/Components";
import { useState } from "react";
import { toast } from "react-toastify";

type TypeaheadData = {
  show: boolean;
  data?: any;
};
const RecordActions = ({
  catalog,
  item,
  onItemChange,
}: {
  catalog?: Array<ItemType<number>>;
  item?: RecordActionType;
  onItemChange: (updatedItem: RecordActionType) => void; // A function to handle item changes
}) => {
  const user = useSelector<ReducerType, LoginInterface>(
    (state) => state.reducerUser
  );
  const [action, setAction] = useState<RecordActionItem>({
    timeTakenId: catalog?.[0].id,
    startDate: new Date().toDateString(),
    endDate: new Date().toDateString(),
    startTime: new Date().getFormattedTime(),
    endTime: new Date().getFormattedTime(),
  });
  const [showList, setshowList] = useState<TypeaheadData>({
    show: false,
  });
  const getServe = useFetch<
    Array<ItemType<number>>,
    unknown,
    {
      filter: string;
    }
  >({
    request: RaytebRequests.Profile_Serves_GET({ token: user.token }),
    onSuccess(data) { },
  });
  const selectedItem = (item: ItemType<number>) => {
    const updatedItem: RecordActionItem = {
      ...action,
      actionId: item.id,
      title: item.title,
    };
    setAction(updatedItem);
    setshowList({ ...showList, show: false });
  };
  const handleAbstractClick = (index: number) => {
    const updatedItems = [...(item?.items || [])];
    updatedItems[index] = {
      ...updatedItems[index],
      showAbstract: !updatedItems[index].showAbstract,
    };
    const checkupData: RecordActionType = {
      ...item,
      items: updatedItems,
    };
    onItemChange && onItemChange(checkupData);
  };
  const handleDeleteClick = (index: number) => {
    const updatedItems = [...(item?.items || [])];
    updatedItems.splice(index, 1);

    const updatedObject = { ...item, items: updatedItems };

    onItemChange && onItemChange(updatedObject);
  };
  const handleStartTimeChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setAction({ ...action, startTime: event.target.value });
  };
  const handleEndTimeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setAction({ ...action, endTime: event.target.value });
  };
  const { Mobile, Desktop, Tablet, Laptop } = useSelector<
    ReducerType,
    DeviceModeInterface
  >((state) => state.reducerDevice);
  const handleAddItem = () => {
    debugger;
    if (!action?.actionId) toast.error("یک مورد انتخاب کنید");
    else {
      const updatedItems = item?.items ? [...item.items] : [];
      if (action.timeTaken === undefined || action.timeTaken === 0) {
        setAction({ ...action, timeTakenId: undefined });
        updatedItems.push({ ...action, timeTakenId: undefined });
      } else {
        if (action.timeTakenId === undefined) {
          setAction({ ...action, timeTakenId: catalog?.[0].id });
        }

        updatedItems.push(action);
      }

      const updatedDiagnosisType: RecordActionType = {
        ...item,
        items: updatedItems,
      };
      onItemChange(updatedDiagnosisType);
      setAction({
        endDate: new Date().toDateString(),
        startDate: new Date().toDateString(),
        startTime: new Date().getFormattedTime(),
        endTime: new Date().getFormattedTime(),
        description: "",
      });
    }
  };
  return (
    <>
      <div className="p-3">
        <ProvideTypeahead
          className={` ${true ? "before:absolute before:z-50 " : ""}`}
          showList={showList.show}
          listChildren={
            <ListChildren
              onClick={(item) => {
                selectedItem(item);
              }}
              listData={getServe.result}
              isLoading={getServe.isLoading}
              onHide={() => setshowList({ show: false })}
            />
          }
        >
          <div className="px-1 flex justify-start  items-end md:!w-1/2 md:mx-auto ">
            <Typeahead
              innerText="اقدام ..."
              className="before:absolute before:bg-white/30 before:w-full before:h-full"
              onClick={(e) => {
                e.target.select();
              }}
              // onBlur={() => setshowList({ ...showList, show: false })}
              onFocus={() => setshowList({ ...showList, show: true })}
              onChange={(e) =>
                getServe.reFetch(null, {
                  filter: e.target.value,
                })
              }
              value={action?.title}
            ></Typeahead>
          </div>
        </ProvideTypeahead>
        <div className="grid xs:grid-cols-2 grid-cols-6 gap-6 mt-3">
          <DatePicker
            innerText="تاریخ شروع"
            isRequired={false}
            className=""
            name="startDate"
            id="startDate"
            raytebValue={action?.startDate}
            value={
              action?.startDate ? new Date(action.startDate).toShamsi() : ""
            }
            onChange={(e) => {
              const fromDateInput = document.getElementById("startDate"); // Assuming you have an element with id "toDate"
              const raytebValue = fromDateInput?.getAttribute("rayteb-value");
              const updatedItem: RecordActionItem = {
                ...action,
                startDate: raytebValue!,
              };
              setAction(updatedItem);
            }}
          />
          <TextBox
            className="w-full h-9 "
            Regular="^(([01]?[0-9]|2[0-3]):[0-5][0-9]){1,5}$"
            RxgMessage="از 00:00 تا 23:59"
            innerText="ساعت شروع"
            isRequired={false}
            debounceTime={0}
            Type={TextBoxTypeEnum.Time}
            value={action?.startTime!}
            onChange={handleStartTimeChange}
          />
          <DatePicker
            innerText="تاریخ پایان"
            isRequired={false}
            className=""
            name="endDate"
            debounceTime={0}
            id="endDate"
            raytebValue={action?.endDate}
            value={action?.endDate ? new Date(action.endDate).toShamsi() : ""}
            onChange={(e) => {
              const fromDateInput = document.getElementById("endDate"); // Assuming you have an element with id "toDate"
              const raytebValue = fromDateInput?.getAttribute("rayteb-value");
              const updatedItem: RecordActionItem = {
                ...action,
                endDate: raytebValue!,
              };
              setAction(updatedItem);
            }}
          />
          <TextBox
            className="w-full h-9 "
            Regular="^(([01]?[0-9]|2[0-3]):[0-5][0-9]){1,5}$"
            RxgMessage="از 00:00 تا 23:59"
            innerText="ساعت پایان"
            isRequired={false}
            Type={TextBoxTypeEnum.Time}
            debounceTime={0}
            value={action?.endTime!}
            onChange={handleEndTimeChange}
          />
          <TextBox
            Type={TextBoxTypeEnum.Number}
            className="h-9"
            debounceTime={0}
            innerText="مدت زمان"
            onChange={(e) => {
              setAction({ ...action, timeTaken: Number(e.target.value) });
            }}
          />
          <Select
            className="w-full h-9"
            onChange={(e) => {
              if (e.target.value && e.target.value !== "") {
                setAction({
                  ...action,
                  timeTakenId: Number(e.target.value),
                });
              }
            }}
            value={action?.timeTaken}
          >
            {catalog?.map((n, i) => (
              <option key={i} value={n.id}>
                {n.title}
              </option>
            ))}
          </Select>
        </div>
        <div className="mt-4 grid grid-cols-9 gap-1">
          <div className="col-span-8">
            <TextBox
              innerText="توضیحات"
              className="w-full "
              debounceTime={0}
              Type={TextBoxTypeEnum.Text}
              value={action?.description}
              onChange={(e) =>
                setAction({ ...action, description: e.target.value })
              }
            />
          </div>
          <Icon
            icon="rayteb-microphone"
            className="text-xl w-full text-disable h-full rounded-full  "
          />
        </div>
        <div className="flex justify-between items-center mt-3 px-1">
          <Icon
            icon="rayteb-add-circular"
            className="text-xl mr-auto text-primaryLight"
            onClick={handleAddItem}
          />
        </div>

        <div className="mt-5 grid grid-cols-1 gap-1 ">
          {item?.items?.map((n, i) => (
            <Card
              key={i}
              text={Mobile ? n.title?.substring(0, 20) : n.title}
              className="w-full "
              footer={
                <CardFooter
                  actionItem={n}
                  onAbstractClick={() => handleAbstractClick(i)}
                  onDeleteClick={() => handleDeleteClick(i)}
                />
              }
            >
              <div className="w-full mt-3 flex xs:flex-col flex-row">
                <span className="text-xs text-primary font-bold ml-2 ">
                  از تاریخ
                </span>
                <span className="text-xs text-primaryLight">
                  {new Date(n.startDate!).toShamsi()} {n.startTime}
                </span>
                <span className="text-xs text-primary font-bold mx-2">
                  تا تاریخ
                </span>
                <span className="text-xs text-primaryLight">
                  {new Date(n.endDate!).toShamsi()} {n.endTime}
                </span>
                <br />
                <span className="text-primaryLight text-xs">
                  {n.timeTaken
                    ? `به مدت ${n.timeTaken} ${catalog?.find((x) => x.id === n.timeTakenId)?.title
                    }`
                    : ""}
                </span>
              </div>
            </Card>
          ))}
        </div>
      </div>
    </>
  );
};
const CardFooter = ({
  actionItem,
  onAbstractClick,
  onDeleteClick,
}: {
  actionItem?: RecordActionItem;
  onAbstractClick: () => void;
  onDeleteClick: () => void;
}) => (
  <>
    <div className="w-full flex justify-between items-center py-3">
      <Button className="bg-white border border-disable py-1 text-xs text-primary">
        {actionItem?.description!}{" "}
      </Button>

      <div className="flex justify-center itmes-center gap-2">
        <Icon
          icon="rayteb-delete"
          className="text-xl text-primary"
          onClick={onDeleteClick}
        />
        <Icon
          icon="rayteb-medical-ophthalmology"
          className={`text-xl  ${actionItem?.showAbstract ? "text-primary" : "text-disable"
            }`}
          onClick={onAbstractClick}
        />
      </div>
    </div>
  </>
);
type ListChildrenType = {
  listData?: Array<ItemType<number>>;
  className?: string | undefined;
  isLoading: boolean;
  onHide?: () => void;
  onClick?: (param: ItemType<number>) => void;
};
const ListChildren: React.FC<ListChildrenType> = ({
  className,
  listData,
  isLoading,
  onClick,
  onHide,
}) => {
  return (
    <>
      <div>
        <LoadingFit isLoading={isLoading} />
        <div className="border-b border-disable bg-white py-2 px-1 flex items-center">
          <Icon
            icon="rayteb-android-close"
            className="text-xl"
            onClick={() => onHide?.()}
          />

          <p className="text-xs mr-2 font-bold text-warn "> اقدام ...</p>
        </div>

        <div className="h-64 overflow-y-auto">
          <ul
            className={`flex justify-center flex-col  
           items-center p-2 shadow-sm gap-3 ${className ?? ""}`}
          >
            {listData?.map((n, i) => (
              <li
                key={i}
                className="flex justify-start items-center h-8  py-1 w-full hover:bg-primaryDefault hover:cursor-pointer "
                onClick={(e) => {
                  e.stopPropagation(); // Prevent the event from reaching the parent div and closing the list

                  onClick?.(n);
                }}
              >
                <p className="text-xs font-bold text-end text-primaryLight">
                  {n.title}
                </p>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </>
  );
};
export default RecordActions;
